import React from 'react';
import AppPage from '../../components/PublicSite/AppPage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';
import COPY from '../../components/PublicSite/copy.json';

// Halaman pendaratan kampanye pemasangan aplikasi, dan tujuan tombol
// "Download our app" di header. Boleh diindeks — lihat catatan di AppPage.js.
async function action() {
  await loadSiteCopy();

  return {
    title: COPY['en-US']['appp.title'],
    description: COPY['en-US']['appp.desc'],
    component: (
      <HeadLessLayout>
        <AppPage />
      </HeadLessLayout>
    ),
  };
}

export default action;
